/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GradeFeeRespVo } from './GradeFeeRespVo';
import {
    GradeFeeRespVoFromJSON,
    GradeFeeRespVoFromJSONTyped,
    GradeFeeRespVoToJSON,
    GradeFeeRespVoToJSONTyped,
} from './GradeFeeRespVo';

/**
 * 
 * @export
 * @interface DeliveryCalculationKrFeeRespVo
 */
export interface DeliveryCalculationKrFeeRespVo {
    /**
     * 仓库ID
     * @type {number}
     * @memberof DeliveryCalculationKrFeeRespVo
     */
    warehouseId?: number;
    /**
     * 运输方式ID
     * @type {number}
     * @memberof DeliveryCalculationKrFeeRespVo
     */
    transportMethodId?: number;
    /**
     * 韩国国内运费分组：1橙火服务，2韩国3PL出库
     * @type {number}
     * @memberof DeliveryCalculationKrFeeRespVo
     */
    orderTypeGroup?: number;
    /**
     * 会员等级运费
     * 会员等级运费列表
     * @type {Array<GradeFeeRespVo>}
     * @memberof DeliveryCalculationKrFeeRespVo
     */
    grades?: Array<GradeFeeRespVo>;
}

/**
 * Check if a given object implements the DeliveryCalculationKrFeeRespVo interface.
 */
export function instanceOfDeliveryCalculationKrFeeRespVo(value: object): value is DeliveryCalculationKrFeeRespVo {
    return true;
}

export function DeliveryCalculationKrFeeRespVoFromJSON(json: any): DeliveryCalculationKrFeeRespVo {
    return DeliveryCalculationKrFeeRespVoFromJSONTyped(json, false);
}

export function DeliveryCalculationKrFeeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryCalculationKrFeeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'orderTypeGroup': json['orderTypeGroup'] == null ? undefined : json['orderTypeGroup'],
        'grades': json['grades'] == null ? undefined : ((json['grades'] as Array<any>).map(GradeFeeRespVoFromJSON)),
    };
}

export function DeliveryCalculationKrFeeRespVoToJSON(json: any): DeliveryCalculationKrFeeRespVo {
    return DeliveryCalculationKrFeeRespVoToJSONTyped(json, false);
}

export function DeliveryCalculationKrFeeRespVoToJSONTyped(value?: DeliveryCalculationKrFeeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'transportMethodId': value['transportMethodId'],
        'orderTypeGroup': value['orderTypeGroup'],
        'grades': value['grades'] == null ? undefined : ((value['grades'] as Array<any>).map(GradeFeeRespVoToJSON)),
    };
}

